<!-- SelectMoveDirModal.vue -->
<template>
  <div class="modal-overlay" v-if="isVisible" @click="closeModal">
    <div class="modal-content" @click.stop>
      <div class="modal-header">
        <svg class="modal-icon" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M19.35,10.04C18.67,6.59 15.64,4 12,4C9.11,4 6.6,5.64 5.35,8.04C2.34,8.36 0,10.91 0,14C0,17.31 2.69,20 6,20H19C21.76,20 24,17.76 24,15C24,12.36 21.95,10.22 19.35,10.04Z"/>
        </svg>
        <h3>选择目标目录</h3>
        <button class="close-btn" @click="closeModal">
          <i class="el-icon-close"></i>
        </button>
      </div>
      
      <div class="modal-body">
        <div class="workdir-info">
          <span class="current-path">当前路径: {{ selectedDir }}</span>
          <button class="confirm-btn" @click="confirmSelection" :disabled="!selectedDir">
            确定
          </button>
        </div>
        
        <div class="file-tree-container">
          <div v-if="loading" class="loading-state">
            <i class="el-icon-loading"></i>
            <span>加载中...</span>
          </div>
          
          <template v-else>
            <!-- 返回上一级按钮 -->
            <div 
              v-if="selectedDir != '/'"
              class="directory-up-button"
              title="返回上一级目录"
              @click="handleUpClick"
            >
              <i class="el-icon-arrow-left"></i>
            </div>
            <dir-select-item
              v-for="(file, index) in fileList"
              :key="file.name + '_' + index"
              :file="file"
              :selected-dir="selectedDir"
              @select="handleSelectDir"
            />
            
            <div v-if="fileList.length === 0" class="empty-state">
              <i class="el-icon-folder-opened"></i>
              <p>此目录为空</p>
            </div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { file_list_path } from '@/js/api_paths';
import DirSelectItem from './DirSelectItem.vue';
import { getParentDirectory } from '@/js/tools';

export default {
  name: 'SelectMoveDirModal',
  components: {
    DirSelectItem
  },
  props: {
  },
  data() {
    return {
      fileList: [],
      expandedFolders: new Set(),
      loading: false,
      selectedDir: '/',  // 当前选中的目录
    }
  },
  computed: {
    isVisible() {
      return this.$store.state.showMoveModal;
    },
  },
  watch: {
    isVisible: {
      handler(newVal) {
        if (newVal) {
          this.refreshAll();
        }
      }
    },
    selectedDir: {
      handler() {
        this.refreshFileList();
      }
    }

  },
  mounted(){
    this.refreshAll();
  },

  methods: {
    handleUpClick(){
      const parentDir = getParentDirectory(this.selectedDir); // 计算上一级目录
      this.selectedDir = parentDir;
    },
    refreshAll(){
      this.selectedDir = this.$store.state.rootDir; // 从当前工作目录开始选择
      this.refreshFileList();
    },
    async refreshFileList() {
      this.loading = true;
      try {
        const token = this.$store.state.token;
        const req = {
          "relative_dir": this.selectedDir // 从最底层根目录开始加载
        };
        
        const response = await fetch(file_list_path, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(req)
        });
        
        const data = await response.json();
        if (data.status === "success") {
          // 只显示文件夹
          this.fileList = data.msg.filter(file => file.isDirectory) || [];
        }
      } catch (error) {
        console.error('加载文件列表失败:', error);
        this.fileList = [];
      } finally {
        this.loading = false;
      }
    },
    
    handleSelectDir(msg) {
      // 只允许选择文件夹
      if (msg.fullPath.endsWith('/')) {
        this.selectedDir = msg.fullPath;
      }
    },
    
    closeModal() {
      this.$store.commit('SET_SHOW_MOVE_MODAL', false);
    },
    
    confirmSelection() {
      if (this.selectedDir) {
        // 触发移动文件信号
        this.$store.commit('CHANGE_MOVE_SIGNAL');
        this.$store.commit('SET_TARGET_DIR', this.selectedDir);
        this.closeModal();
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  backdrop-filter: blur(2px);
}

.modal-content {
  background: linear-gradient(145deg, #ffffff, #f8f9fa);
  border-radius: 12px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
  width: 500px;
  max-width: 95%;
  height: 45vh; /* 改为固定高度 40% 视口高度 */
  animation: modalFadeIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.modal-header {
  padding: 20px 24px;
  display: flex;
  align-items: center;
  background: linear-gradient(120deg, #8a2be2 0%, #9370db 100%);
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  flex-shrink: 0; /* 防止头部被压缩 */
}

.modal-icon {
  color: rgba(255, 255, 255, 0.9);
  margin-right: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}

.modal-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.5px;
  flex: 1;
}

.close-btn {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  font-size: 20px;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;
  margin-left: auto;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: white;
}

.modal-body {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0; /* 重要：允许子元素正确计算高度 */
}

.workdir-info {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
  flex-shrink: 0; /* 防止信息栏被压缩 */
}

.current-path {
  font-size: 14px;
  color: #6c757d;
  font-family: 'Monaco', 'Consolas', monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
}

.confirm-btn {
  padding: 8px 16px;
  background: linear-gradient(135deg, #8a2be2 0%, #6a0dad 100%);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 2px 6px rgba(138, 43, 226, 0.3);
}

.confirm-btn:hover:not(:disabled) {
  background: linear-gradient(135deg, #7a1bd2 0%, #5a0b9d 100%);
  box-shadow: 0 4px 12px rgba(138, 43, 226, 0.4);
  transform: translateY(-1px);
}

.confirm-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.file-tree-container {
  flex: 1;
  overflow-y: auto; /* 关键：启用纵向滚动 */
  padding: 8px 0;
  min-height: 0; /* 重要：允许正确计算滚动 */
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: #6c757d;
}

.loading-state i {
  font-size: 24px;
  margin-right: 12px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #94a3b8;
}

.empty-state i {
  font-size: 48px;
  margin-bottom: 16px;
  display: block;
  opacity: 0.7;
}

.empty-state p {
  margin: 0;
  font-size: 16px;
  color: #64748b;
}

.directory-up-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  margin-bottom: 8px;
  font-size: 14px;
  color: #606266;
  cursor: pointer;
  border-radius: 4px;
  user-select: none;
  transition: all 0.3s ease;
}

/* Hover 状态 */
.directory-up-button:hover {
  color: #8a2be2;
  background-color: rgba(138, 43, 226, 0.05);
}

/* 点击状态（active） */
.directory-up-button:active {
  background-color: #d9ecff;
  transform: translateY(0.5px);
}
</style>